import React from "react";
import { Card, CardContent, Grid, Skeleton } from "@mui/material";
import styles from "../../featuredBooks/style.module.scss";

// Mirrors the markup of featuredBooks/card in its `bestSellers` variant, reusing
// the same classes so the placeholder keeps the card's real height and split.
function SkeletonLoader() {
  return (
    <Grid
      md={12}
      lg={6}
      xl={6}
      xs={12}
      padding={"10px"}
      sx={{ boxSizing: "border-box" }}
    >
      <Card>
        <CardContent className={styles.bestSellersCard}>
          <div className={styles.imageWrapper}>
            <Skeleton variant="rectangular" width={"100%"} height={"100%"} />
          </div>

          <div className={styles.headings}>
            <Skeleton variant="text" width={"80%"} height={28} />

            <div className={styles.copiesContainer}>
              <div>
                <Skeleton variant="text" width={110} height={22} />
                <Skeleton variant="text" width={45} height={22} />
              </div>
              <div>
                <Skeleton variant="text" width={110} height={22} />
                <Skeleton variant="text" width={45} height={22} />
              </div>
            </div>

            <div className={styles.categoryContainer}>
              <Skeleton variant="rounded" width={70} height={24} />
              <Skeleton variant="rounded" width={90} height={24} />
            </div>

            <Skeleton
              variant="rounded"
              width={130}
              height={34}
              sx={{ marginTop: "auto" }}
            />
          </div>
        </CardContent>
      </Card>
    </Grid>
  );
}

export default SkeletonLoader;
